// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ContentActionButtons_buttonsWrapper__Cdldj","actionButton":"ContentActionButtons_actionButton__iJtsl"};